import { defineMessages } from 'react-intl';

export const layout = defineMessages({
  personalInformation: {
    id: 'Onboarding.personalInformation',
    defaultMessage: 'Our privacy policy'
  },
  skip: {
    id: 'Onboarding.skip',
    defaultMessage: 'Skip step'
  }
});

export const nameForm = defineMessages({
  heading: {
    id: 'Onboarding.NameForm.heading',
    defaultMessage: 'What is your name?'
  },
  label: {
    id: 'Onboarding.NameForm.label',
    defaultMessage: 'First name'
  },
  description: {
    id: 'Onboarding.NameForm.description',
    defaultMessage:
      'This lets us know who we are talking to when we communicate with you. This is optional.'
  }
});

export const birthYearForm = defineMessages({
  heading: {
    id: 'Onboarding.BirthYearForm.heading',
    defaultMessage: 'Your year of birth'
  },
  description: {
    id: 'Onboarding.BirthYearForm.description',
    defaultMessage:
      'Your age helps us understand who are using the service, and why. This is optional.'
  }
});

export const genderForm = defineMessages({
  heading: {
    id: 'Onboarding.GenderForm.heading',
    defaultMessage: "I'm a"
  },
  description: {
    id: 'Onboarding.GenderForm.description',
    defaultMessage:
      'Your gender helps us understand who are using the service, and why. This is optional.'
  }
});

export const postalCodeForm = defineMessages({
  heading: {
    id: 'Onboarding.PostalCodeForm.heading',
    defaultMessage: 'What is your postal code?'
  },
  label: {
    id: 'postal_code',
    defaultMessage: 'Postal code'
  },
  description: {
    id: 'Onboarding.PostalCodeForm.description',
    defaultMessage:
      'Your location helps us understand who are using the service, and why. This is optional.'
  }
});

export const emailForm = defineMessages({
  heading: {
    id: 'Onboarding.EmailForm.heading',
    defaultMessage: 'Stay updated by e-mail'
  },
  label: {
    id: 'Onboarding.EmailForm.label',
    defaultMessage: 'Your e-mail'
  },
  description: {
    id: 'Onboarding.EmailForm.description',
    defaultMessage: 'Enter your email to get receipts.'
  },
  emailNotRequired: {
    id: 'Onboarding.EmailForm.emailNotRequired',
    defaultMessage: 'You can unsubscribe whenever you want.'
  },
  emailRequired: {
    id: 'Onboarding.EmailForm.emailRequired',
    defaultMessage: 'A valid email is required.'
  },
  required: {
    id: 'Onboarding.EmailForm.required',
    defaultMessage: 'Please enter a valid email address.'
  }
});

export const obosStep = defineMessages({
  noObos: {
    id: 'Onboarding.ObosStep.noObos',
    defaultMessage:
      'We did not find your phone number at OBOS. You can add it on {obosLink}'
  }
});
